/**
 * Extract error message from API error response
 * Handles both old and new error formats
 */
export const getErrorMessage = (error) => {
  if (!error.response) {
    return error.message || 'Network error. Please check your connection.';
  }

  const { data } = error.response;

  // New error format: { success: false, error: { code, message, errors, details } }
  if (data.error) {
    if (data.error.errors && Array.isArray(data.error.errors)) {
      // Multiple validation errors
      return data.error.errors.join(', ');
    }
    return data.error.message || 'An error occurred';
  }

  // Old error format: { message: "..." }
  if (data.message) {
    return data.message;
  }

  // Fallback
  return `Error ${error.response.status}: ${error.response.statusText || 'Unknown error'}`;
};

/**
 * Get error code from API error response
 */
export const getErrorCode = (error) => {
  if (!error.response) {
    return 0;
  }

  const { data } = error.response;

  // New error format
  if (data.error && data.error.code) {
    return data.error.code;
  }

  // Fallback to HTTP status code
  return error.response.status || 500;
};
